// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"35004d16","977":"0c508f41"}[chunkId] + ".chunk.js";
};